import { defineFcm } from '../shared/factory';

export const FCM_LCM_STARTER_SIGNATURE_MILESTONE_ENABLED = defineFcm('lcm_starter_signature_milestone_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Enables sending starter petition signature milestone messages to Iterable.',
		import: false,
	});
